import { createIcon } from './createIcon';

/**
 * Circled "+". A bare plus reads thin at the sidebar's 12px font-size, so the
 * ring gives it enough weight to sit alongside the folder and clock glyphs.
 */
export const NewChatIcon = createIcon({
  name: 'NewChatIcon',
  viewBox: '0 0 24 24',
  size: 16,
  color: 'var(--text-secondary)',
  children: (
    <path
      d="M16.2426 12.0005H7.75736M12 16.2431V7.75781M21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  ),
});

export default NewChatIcon;
